module.exports = "<div class=\"py-2\">\r\n  <div *ngIf=\"!mediaViewerUrl\">No media viewer available</div>\r\n  <cco-button *ngIf=\"mediaViewerUrl\" content='Launch Media Viewer' buttonStyle='primary' (click)=\"openMediaViewer()\"></cco-button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-media/claim-media.component.html
// module id = ../../../../../src/app/claim/claim-media/claim-media.component.html
// module chunks = main